import React from "react"
import Navheader from "./components/NavHeader/NavHeader"
import MainContent from "./components/MainContent/MainContent"


function App(){

    return(
    <div>
    <Navheader/>
    <MainContent/> 
    
    </div>
        )
}

export default App